import { PropsWithChildren } from 'react'
import { cn } from '@/ui/utils/style'

interface BadgeProps extends PropsWithChildren {
  className?: string
}

export function Badge({ children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'block rounded-[6px] border border-white/15 bg-white/5 px-2 py-1 font-normal text-[11px] text-link-inactive leading-tight',
        className,
      )}
    >
      {children}
    </span>
  )
}
